import { Pipe, PipeTransform, inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'thousands',
})
export class ThousandsPipe implements PipeTransform {
  private decimalPipe = inject(DecimalPipe);

  transform(value: string | number | undefined, space?: 'non-breaking' | 'breaking'): string | undefined {
    if (value === undefined || value === null) return;
    if (typeof value === 'string') value = parseInt(value.replace(/\D/g, ''));
    value = this.decimalPipe.transform(value, '1.0-0') ?? '0';
    const spaceSymbol = space === 'breaking' ? ' ' : '\u00A0';
    value = value.replace(/,/g, spaceSymbol);
    return value;
  }
}
